<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Overzicht verwerkingsdefinitie'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Verwerkingsdefinitie</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Verwerkingsdefinitie laden...'" />
    </div>
  } @else {
  <!-- Details card -->
  <yds-card-editable
    #detailsCard
    title="Details"
    [(editing)]="detailsEditing"
    [editDisabled]="isSaving() || outputEditing()"
    [nextDisabled]="isSaving() || form.invalid"
    [nextLabel]="isAddMode() ? 'Volgende' : 'Opslaan'"
    (cancel)="onDetailsCancel()"
    (next)="onDetailsNext()"
  >
    @if (notFound()) {
      <p class="jpd-empty">Er zijn geen details voor verwerkingsdefinitie gevonden.</p>
    } @else if (detailsEditing()) {
      <form class="gl-form" [formGroup]="form">
        <p class="gl-form__required-hint">
          Velden gemarkeerd met een sterretje
          (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
        </p>

        <div class="gl-field">
          <label class="gl-field__label">
            <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Verwerkingsdefinitie 
          </label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="name"
              [required]="true"
              [maxLength]="100"
              [hasError]="isInvalid(form.get('name'))"
              [errorMsg]="'Verwerkingsdefinitie is verplicht.'"
              [placeholder]="'Vul een verwerkingsdefinitie in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Boekingsgroep</label>
          <div class="gl-field__control">
            <p class="gl-field__readonly-text">{{ bookingGroupName() || 'n.v.t.' }}</p>
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Omschrijving boeking</label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="bookingDescription"
              [placeholder]="'Voer een omschrijving in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Bedrijfsnummer (FA)</label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="institutionFinancialAdministrationNumber"
              [placeholder]="'Voer een bedrijfsnummer in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Boekstuknummer</label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="bookingNumber"
              [placeholder]="'Voer een boekstuknummer in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Dagboeknummer</label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="journalNumber"
              [placeholder]="'Voer een dagboeknummer in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Dagboektype</label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="journalType"
              [placeholder]="'Voer een dagboektype in'"
            />
          </div>
        </div>
      </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Verwerkingsdefinitie</span>
          <span class="gl-detail__value">{{ nameDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekingsgroep</span>
          <span class="gl-detail__value">{{ bookingGroupName() || 'n.v.t.' }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Omschrijving boeking</span>
          <span class="gl-detail__value">{{ bookingDescriptionDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Bedrijfsnummer (FA)</span>
          <span class="gl-detail__value">{{ institutionNumberDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekstuknummer</span>
          <span class="gl-detail__value">{{ bookingNumberDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Dagboeknummer</span>
          <span class="gl-detail__value">{{ journalNumberDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Dagboektype</span>
          <span class="gl-detail__value">{{ journalTypeDisplay() }}</span>
        </div>
      </div>
    }
  </yds-card-editable>

  <!-- Uitvoerparameters card -->
  <yds-card-editable
    #outputCard
    class="jpd-card"
    title="Uitvoerparameters"
    [(editing)]="outputEditing"
    [editDisabled]="isSaving() || detailsEditing()"
    [nextDisabled]="isSaving() || form.invalid"
    nextLabel="Opslaan"
    (cancel)="onOutputCancel()"
    (next)="onOutputNext()"
  >
    @if (notFound()) {
      <p class="jpd-empty">Er zijn geen uitvoerparameters gevonden.</p>
    } @else if (outputEditing()) {
      <form class="gl-form" [formGroup]="form">
        <p class="gl-form__required-hint">
          Velden gemarkeerd met een sterretje
          (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
        </p>

        <div class="gl-field">
          <label class="gl-field__label">Persoonselectie</label>
          <div class="gl-field__control">
            <yds-combobox
              formControlName="employmentSelectionId"
              [items]="employmentSelectionOptions()"
              [allowClear]="true"
              [placeholder]="'Selecteer een persoonselectie'"
            />
          </div>
        </div>

        <div class="gl-form__switches">
          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Toepassen loonverdeling</label>
            <div class="gl-field__control">
              <yds-switch formControlName="applyWagePartioning" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Toepassen herverdeling</label>
            <div class="gl-field__control">
              <yds-switch formControlName="applyRedistribution" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Boeken per persoon</label>
            <div class="gl-field__control">
              <yds-switch formControlName="bookByEmployment" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">Boeken negatieve waarden</label>
            <div class="gl-field__control">
              <yds-switch formControlName="bookNegativeValuesIndicator" />
            </div>
          </div>

          <div class="gl-field gl-field--inline">
            <label class="gl-field__label">TWK boeken in afrekenperiode</label>
            <div class="gl-field__control">
              <yds-switch formControlName="retroactiveCalculationInPayrollPeriod" />
            </div>
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">
            <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Begindatum 
          </label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="startDate"
              [required]="true"
              [locale]="translate.getCurrentLang()"
              [placeholderKey]="null"
              [placeholder]="''"
              [allowTodayAction]="false"
              [dateFilter]="firstDayOfMonthFilter"
              [errorMessage]="isInvalid(form.get('startDate')) ? 'Begindatum is verplicht.' : ''"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">
            Einddatum 
          </label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="endDate"
              [required]="false"
              [locale]="translate.getCurrentLang()"
              [placeholderKey]="null"
              [placeholder]="''"
              [allowTodayAction]="false"
              [dateFilter]="lastDayOfMonthFilter"
              [errorMessage]="endDateError()"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Memo</label>
          <div class="gl-field__control">
            <yds-text-area
              formControlName="memoValue"
              [placeholder]="'Voer een memo in'"
              [maxLength]="500"
              [showCounter]="true"
            />
          </div>
        </div>
      </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Persoon selectie</span>
          <span class="gl-detail__value">{{ employmentSelectionDisplay() }}</span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Toepassen loonverdeling</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (applyWagePartioningDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Toepassen herverdeling</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (applyRedistributionDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Boeken per persoon</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (bookByEmploymentDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Boeken negatieve waarden</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (bookNegativeValuesDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">TWK boeken in afrekenperiode</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (retroactiveCalculationDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Begindatum</span>
          <span class="gl-detail__value">{{ startDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Einddatum</span>
          <span class="gl-detail__value">{{ endDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Memo</span>
          <span class="gl-detail__value gl-detail__value--memo">{{ memoDisplay() }}</span>
        </div>
      </div>
    }
  </yds-card-editable>
  }
</div>
